module.exports = __webpack_public_path__ + "media/img/home/our-work/line-a74b2d49b0b7acba12bd1f0a45897c54.svg";